import Model from 'mixins/model';
import ArticleNotificationModel from 'models/ArticleNotificationModel';

export class ArticlesNotificationModel extends Model {
  constructor() {
    super();
    this.set('lastVisitAt');
    this.set('articles', []);
  }
  update(data) {
    const { lastVisitAt, articles, newSinceLastVisit} = data;

    const articlesModels = [];

    articles.forEach((model) => articlesModels
      .push(ArticleNotificationModel.fromJSON(model)));

    this.set('lastVisitAt', lastVisitAt);
    this.set('articles', articlesModels);
    this.set('newSinceLastVisit', newSinceLastVisit);

    this.fireEvent('updated');
  }
}

export const articlesNotificationModel = new ArticlesNotificationModel();

export default articlesNotificationModel;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/ArticlesNotificationModel.js